module.exports = __webpack_public_path__ + "media/images/ac_templates/201-gryht-base-355987f6f594400d7f02cb58fdbefa84.png";